
import React, { Component } from 'react';
// import ReactResizeDetector from 'react-resize-detector';
import StripTags from '../../helpers/StripTags';

import '../../styles/Dot.scss';
//
//

export default class Dot extends React.Component<any> {
  closeButtonOnClick(e) {
    e.preventDefault()
    e.stopPropagation()
      (window as any).Swivl.unmount()
  }

  renderCloseButton() {
    if (!this.props.config.showCloseButton) { return null; }
    return <div className={"sce-closeButton " + "sce-closeButtonPosition-" + this.props.config.position} onClick={this.closeButtonOnClick}>
      <div className="sce-closeX" />
    </div>
  }

  render() {

    var avatar, headingLeft;
    var left = this.props.layout.leftPadding + 12;

    if (this.props.config.settings.avatarURL) {
      avatar = <img src={this.props.config.settings.avatarURL} alt={"Chatbot Avatar"} />
    }


    const isPhone = (this.props.isMobile && !this.props.isTablet)

    var dotStyle: any = {}
    if (!isPhone && (this.props.config.position == "right" || this.props.config.position == "left")) {
      dotStyle.top = ((this.props.windowSize.height - 60) / 2) + "px";
    } else if (this.props.config.position == "bottom-center") {
      dotStyle.left = ((this.props.windowSize.width - 60) / 2) + "px";
      dotStyle.right = "auto";

    }
    if (!this.props.isMobile) {
      if (this.props.config.dotDesktopLeftOffset) { dotStyle.left = this.props.config.dotDesktopLeftOffset + "px"; }
      if (this.props.config.dotDesktopRightOffset) { dotStyle.right = this.props.config.dotDesktopRightOffset + "px"; }
    }
    if (this.props.config.dotOffsets) {
      if (this.props.config.dotOffsets.mobile && this.props.isMobile) {
        if (this.props.config.dotOffsets.mobile.top) {
          dotStyle.top = this.props.config.dotOffsets.mobile.top + "px";
        }
        if (this.props.config.dotOffsets.mobile.bottom) {
          dotStyle.bottom = this.props.config.dotOffsets.mobile.bottom + "px";
        }
        if (this.props.config.dotOffsets.mobile.left) {
          dotStyle.left = this.props.config.dotOffsets.mobile.left + "px";
        }
        if (this.props.config.dotOffsets.mobile.right) {
          dotStyle.right = this.props.config.dotOffsets.mobile.right + "px";
        }

        if (this.props.config.dotOffsets.desktop && !this.props.isMobile) {
          if (this.props.config.dotOffsets.desktop.top) {
            dotStyle.top = this.props.config.dotOffsets.desktop.top + "px";
          }
          if (this.props.config.dotOffsets.desktop.bottom) {
            dotStyle.bottom = this.props.config.dotOffsets.desktop.bottom + "px";
          }
          if (this.props.config.dotOffsets.desktop.left) {
            dotStyle.left = this.props.config.dotOffsets.desktop.left + "px";
          }
          if (this.props.config.dotOffsets.desktop.right) {
            dotStyle.right = this.props.config.dotOffsets.desktop.right + "px";
          }
        }
      }


    }

    let mobileClass = (isPhone) ? " sce-dotMobile" : "";
    if (this.props.isTablet) {
      mobileClass = " sce-dotTablet"
    }
    var dotText;
    if (this.props.customDotText) {
      dotText = this.props.customDotText;
    } else if (this.props.config.dotText) {
      dotText = this.props.config.dotText;
    } else {
      dotText = this.props.config.headerText;
    }

    const className = "sce-Dot sce-DotPosition-" + this.props.config.position + mobileClass;

    const title = (this.props.hideTitle) ? null : <div
      className="sce-dotTitle  swivl-body">
      <div dangerouslySetInnerHTML={{ __html: StripTags(dotText) }}
      />
      {this.renderCloseButton()}

    </div>

    return <div
      className={className}
      onClick={this.props.toggleOpen}
      style={dotStyle}
    >
      <span className="ping"></span>
      <div className="sce-dotAvatar swivl-header" >{avatar}</div>
      {title}
    </div>;
  }

}
